import { render, staticRenderFns } from "./TagMultiSelect.vue?vue&type=template&id=40f32506&scoped=true"
import script from "./TagMultiSelect.vue?vue&type=script&lang=js"
export * from "./TagMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./TagMultiSelect.vue?vue&type=style&index=0&id=40f32506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f32506",
  null
  
)

export default component.exports